// extracted by mini-css-extract-plugin
export default {"container":"BigLogo_container__jsGmU","circle":"BigLogo_circle__4ptJs","icon":"BigLogo_icon__hGLgQ"};